import { render, staticRenderFns } from "./contactForm.vue?vue&type=template&id=522017a0&scoped=true"
import script from "./contactForm.vue?vue&type=script&lang=js"
export * from "./contactForm.vue?vue&type=script&lang=js"
import style0 from "./contactForm.vue?vue&type=style&index=0&id=522017a0&prod&lang=scss&scoped=true"
import style1 from "./contactForm.vue?vue&type=style&index=1&id=522017a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522017a0",
  null
  
)

export default component.exports